import React from 'react'
import { Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function RequiredFieldLabel() {
  const [t] = useTranslation()
  return <Paragraph size="xs" secondary>{`* ${t('required.field', 'Required Field')}`}</Paragraph>
}
